module.exports = __webpack_public_path__ + "static/15-Intel-ca0b961d5e2786e3905daec5659c4e39.png";